import { render } from "./download-Sekolah.vue?vue&type=template&id=31cbb358&ts=true"
import script from "./download-Sekolah.vue?vue&type=script&lang=ts"
export * from "./download-Sekolah.vue?vue&type=script&lang=ts"

import "./download-Sekolah.vue?vue&type=style&index=0&id=31cbb358&lang=scss"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__